import { InstallationType } from "../local-installation/types";
export const NETWORK_TYPE_OPTIONS = [
    {
        value: "fernwaerme_alt",
        factor: 0.26,
    },
    {
        value: "fernwaerme_neu",
        factor: 0.21,
    },
    {
        value: "nahwaerme",
        factor: 0.19,
    },
    {
        value: "stromnetz",
        factor: 0,
    },
];
export const HEAT_NETWORK_TYPE_OPTIONS = NETWORK_TYPE_OPTIONS.filter((option) => option.value !== "stromnetz");
export const ELECTRICITY_NETWORK_TYPE_OPTIONS = NETWORK_TYPE_OPTIONS.filter((option) => option.value === "stromnetz");
export const getNetworkTypeOptionsByInstallationType = (installationType) => {
    if (installationType === InstallationType.RenewableEnergyLawInstallation) {
        return ELECTRICITY_NETWORK_TYPE_OPTIONS;
    }
    return HEAT_NETWORK_TYPE_OPTIONS;
};
export const getNetworkTypeOption = (value) => {
    return NETWORK_TYPE_OPTIONS.find((option) => option.value === value);
};
export const getAllNetworkTypeOptions = () => {
    return [...NETWORK_TYPE_OPTIONS];
};
export const getNetworkTypeFactor = (value) => {
    const option = getNetworkTypeOption(value);
    return option?.factor;
};
